module.exports = __webpack_public_path__ + "img/downarrow.b338988b.svg";